(function(){
  'use strict';
  var drawer,trigger,backdrop,closeBtn,tourSelect,titleEl,imageEl,nameEl,emailEl,phoneEl,phoneFull,dateEl,langRow,langSelect,timeRow,timeSelect,travelers,totalEl,statusEl,bookBtn;
  var activeData=null,lastFocus=null;

  function $(id){return document.getElementById(id)}
  function txt(v){return String(v==null?'':v).trim()}
  function cp(key,fallback){return drawer&&drawer.dataset[key]?drawer.dataset[key]:fallback}
  function resolveDataId(id){
    id=txt(id);
    if(!id)return tourSelect&&tourSelect.value||'';
    if($(id))return id;
    var m=id.match(/(?:tour-data-|pmy-checkout-data-)?(\d+)/);
    if(m&&$('pmy-checkout-data-'+m[1]))return 'pmy-checkout-data-'+m[1];
    return id;
  }
  function parseData(id){
    var el=$(resolveDataId(id));
    if(!el)return null;
    try{return JSON.parse(el.textContent||'{}')}catch(e){

      return null;
    }
  }
  function list(v){
    if(Array.isArray(v))return v.map(txt).filter(Boolean);
    if(v==null)return[];
    if(typeof v==='object'&&v.value!=null)return list(v.value);
    if(typeof v==='string'){
      var s=v.trim();
      if(!s)return[];
      try{
        var p=JSON.parse(s);
        if(Array.isArray(p))return p.map(txt).filter(Boolean);
      }catch(e){}
      return s.split(/[,;|\n]+/).map(txt).filter(Boolean);
    }
    return[txt(v)].filter(Boolean);
  }
  function money(cents,symbol){ var n=Number(cents||0)/100,locale=document.documentElement.lang||'en',html=document.documentElement,code=(html&&html.dataset&&html.dataset.pmyCurrencyCode)||'',fallback=(html&&html.dataset&&html.dataset.pmyCurrencySymbol)||symbol||'€'; try{if(code)return new Intl.NumberFormat(locale,{style:'currency',currency:code}).format(n)}catch(e){} try{return (symbol||fallback)+n.toLocaleString(locale,{minimumFractionDigits:2,maximumFractionDigits:2})}catch(e){return (symbol||fallback)+n.toFixed(2)} }
  function status(message){
    if(!statusEl)return;
    if(!message){statusEl.hidden=true;statusEl.textContent='';return}
    statusEl.hidden=false;
    statusEl.textContent=message;
  }
  function openDrawer(){
    if(!drawer)return;
    if(tourSelect&&tourSelect.value&&(!activeData||resolveDataId(tourSelect.value)!==resolveDataId('pmy-checkout-data-'+activeData.product_id)))syncProduct(tourSelect.value);
    lastFocus=document.activeElement;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    backdrop.setAttribute('aria-hidden','false');
    trigger.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    trigger.setAttribute('aria-expanded','true');
    document.body.classList.add('pmy-checkout-lock');
    var l=trigger.querySelector('[data-pmy-checkout-trigger-label]');
    if(l)l.textContent=cp('labelClose','Close');
    setTimeout(function(){closeBtn&&closeBtn.focus({preventScroll:true})},20);
  }
  function closeDrawer(){
    if(!drawer)return;
    if(window.PMYTracking&&typeof window.PMYTracking.abandonForm==='function'){
      try{window.PMYTracking.abandonForm('global_checkout_drawer','drawer_closed')}catch(e){}
    }
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    trigger.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    trigger.setAttribute('aria-expanded','false');
    document.body.classList.remove('pmy-checkout-lock');
    var l=trigger.querySelector('[data-pmy-checkout-trigger-label]');
    if(l)l.textContent=cp('labelCheckout','Checkout');
    backdrop.setAttribute('aria-hidden','true');
    if(lastFocus&&lastFocus.focus)setTimeout(function(){lastFocus.focus({preventScroll:true})},10);
  }
  function toggleDrawer(){drawer&&drawer.classList.contains('is-open')?closeDrawer():openDrawer()}

  var dayMap={sunday:0,sun:0,domingo:0,monday:1,mon:1,segunda:1,'segunda-feira':1,tuesday:2,tue:2,terca:2,'terça':2,'terça-feira':2,wednesday:3,wed:3,quarta:3,'quarta-feira':3,thursday:4,thu:4,quinta:4,'quinta-feira':4,friday:5,fri:5,sexta:5,'sexta-feira':5,saturday:6,sat:6,sabado:6,'sábado':6};
  function dayNumber(v){
    var s=txt(v).toLowerCase();
    if(/^\d$/.test(s)){var n=Number(s);return n>=0&&n<=6?n:null}
    return Object.prototype.hasOwnProperty.call(dayMap,s)?dayMap[s]:null;
  }
  function dateKey(v){
    var s=txt(v),m=s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if(m)return s;
    m=s.match(/^(\d{1,2})[\/.\-](\d{1,2})[\/.\-](\d{4})$/);
    if(m)return m[3]+'-'+String(m[2]).padStart(2,'0')+'-'+String(m[1]).padStart(2,'0');
    return s;
  }
  function blocked(value){
    if(!activeData||!value)return false;
    var k=dateKey(value),parts=k.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if(!parts)return false;
    var days=list(activeData.blocked_days).map(dayNumber).filter(function(x){return x!==null});
    var dates=list(activeData.blocked_dates).map(dateKey);
    var d=new Date(Number(parts[1]),Number(parts[2])-1,Number(parts[3]));
    return days.indexOf(d.getDay())!==-1||dates.indexOf(k)!==-1;
  }
  function applyDateRules(){
    if(!dateEl)return;
    var today=new Date();
    today.setMinutes(today.getMinutes()-today.getTimezoneOffset());
    dateEl.min=today.toISOString().slice(0,10);
    if(dateEl.value&&blocked(dateEl.value))dateEl.value='';
    if(dateEl._flatpickr){
      dateEl._flatpickr.set('minDate','today');
      dateEl._flatpickr.set('disable',[function(d){
        var k=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
        return blocked(k);
      }]);
      dateEl._flatpickr.redraw();
    }
  }
  function scheduleDateRules(){applyDateRules();setTimeout(applyDateRules,180);setTimeout(applyDateRules,650)}

  function populateLanguages(data){
    var langs=list(data&&data.languages);
    var placeholder=langSelect.options[0]?langSelect.options[0].textContent:'Select a language';
    langSelect.innerHTML='';
    var p=document.createElement('option');
    p.value='';
    p.textContent=placeholder;
    langSelect.appendChild(p);
    langs.forEach(function(v){
      var o=document.createElement('option');
      o.value=v;
      o.textContent=v;
      langSelect.appendChild(o);
    });
    var massage=!!data.is_massage;
    langRow.hidden=massage||!langs.length;
    timeRow.hidden=!massage;
    if(!massage&&langs.length===1)langSelect.value=langs[0];
  }

  function clean(v){
    v=txt(v);
    return /^(default title|default)$/i.test(v)?'':v;
  }
  function isTime(v){return /(\d{1,2}:\d{2}|\d{1,2}h\d{2})/i.test(txt(v))}
  function groupVariants(data){
    var variants=Array.isArray(data&&data.variants)?data.variants:[];
    var map={},order=[];

    variants.forEach(function(v){
      var rawOptions=Array.isArray(v.options)?v.options:[v.option1,v.option2,v.option3];
      var options=rawOptions.map(clean).filter(Boolean);
      var catName='',choice='';

      if(options.length>=2){
        catName=options[0];
        choice=options.slice(1).join(' / ');
      }else if(options.length===1){
        var titleParts=txt(v.title).split(' / ').map(txt).filter(Boolean);
        if(titleParts.length>=2){
          catName=titleParts.shift();
          choice=titleParts.join(' / ');
        }else{
          catName=options[0];
        }
      }else{
        var fallbackParts=txt(v.title).split(' / ').map(txt).filter(Boolean);
        if(fallbackParts.length>=2){
          catName=fallbackParts.shift();
          choice=fallbackParts.join(' / ');
        }else{
          catName=cp('labelTravelers','Select Tickets');
        }
      }

      if(!catName)catName=cp('labelTravelers','Select Tickets');

      if(!map[catName]){
        map[catName]={
          label:catName,
          choices:[],
          defaultPrice:Number(v.price||0),
          defaultId:Number(v.id||0)
        };
        order.push(catName);
      }

      if(choice&&!map[catName].choices.some(function(item){return String(item.id)===String(v.id)})){
        map[catName].choices.push({
          label:choice,
          price:Number(v.price||0),
          id:Number(v.id||0)
        });
      }
    });

    return order.map(function(key){return map[key]});
  }

  function row(group,data){
    var wrap=document.createElement('div');
    wrap.className='traveler-row';

    var info=document.createElement('div');
    info.className='traveler-info';

    var h=document.createElement('h6');
    h.textContent=group.label;
    h.title=group.label;
    info.appendChild(h);

    var selectedId=group.defaultId;
    var selectedPrice=group.defaultPrice;
    var qty;

    if(group.choices.length){
      var sel=document.createElement('select');
      sel.className='traveler-time-select';
      sel.setAttribute('aria-label',group.label);
      group.choices.forEach(function(choice){
        var o=document.createElement('option');
        o.value=String(choice.id);
        o.dataset.price=String(choice.price);
        o.dataset.choice=choice.label;
        o.textContent=choice.label;
        sel.appendChild(o);
      });
      selectedId=Number(sel.options[0].value||selectedId);
      selectedPrice=Number(sel.options[0].dataset.price||selectedPrice);
      info.appendChild(sel);
      sel.addEventListener('change',function(){
        var o=sel.options[sel.selectedIndex];
        qty.dataset.variantId=o.value;
        qty.dataset.price=o.dataset.price||'0';
        qty.dataset.choice=o.dataset.choice||o.textContent||'';
        price.textContent=money(o.dataset.price,data.currency_symbol);
        updateTotal();
      });
    }

    var price=document.createElement('span');
    price.className='traveler-price';
    price.textContent=money(selectedPrice,data.currency_symbol);
    info.appendChild(price);
    wrap.appendChild(info);

    var ctrl=document.createElement('div');
    ctrl.className='qty-selector';

    var minus=document.createElement('button');
    minus.type='button';
    minus.className='qty-ctrl';
    minus.textContent='−';
    minus.setAttribute('aria-label',cp('labelDecrease','Decrease')+' '+group.label);

    qty=document.createElement('input');
    qty.type='number';
    qty.className='traveler-qty';
    qty.min='0';
    qty.max='20';
    qty.value=/(adult|adulto|adulte|erwachsen|volwassen|بالغ|מבוגר)/i.test(group.label)?'1':'0';
    qty.dataset.variantId=String(selectedId);
    qty.dataset.price=String(selectedPrice);
    qty.dataset.label=group.label;
    qty.dataset.choice=group.choices.length?group.choices[0].label:'';
    qty.setAttribute('aria-label',cp('labelQuantity','Quantity')+' '+group.label);

    var plus=document.createElement('button');
    plus.type='button';
    plus.className='qty-ctrl';
    plus.textContent='+';
    plus.setAttribute('aria-label',cp('labelIncrease','Increase')+' '+group.label);

    ctrl.append(minus,qty,plus);
    wrap.appendChild(ctrl);

    function change(n){
      qty.value=String(Math.max(0,Math.min(20,Number(qty.value||0)+n)));
      updateTotal();
    }
    minus.onclick=function(){change(-1)};
    plus.onclick=function(){change(1)};
    qty.oninput=function(){
      qty.value=String(Math.max(0,Math.min(20,Number(qty.value||0))));
      updateTotal();
    };
    return wrap;
  }

  function buildTravelers(data){
    travelers.innerHTML='';
    var groups=groupVariants(data);
    groups.forEach(function(group){travelers.appendChild(row(group,data))});
    updateTotal();
    setTimeout(function(){
      if(window.PMYCheckoutUIV2&&typeof window.PMYCheckoutUIV2.refresh==='function'){
        window.PMYCheckoutUIV2.refresh(travelers);
      }
    },0);
  }
  function updateTotal(){
    var sum=0;
    document.querySelectorAll('#dynamic-travelers-container .traveler-qty').forEach(function(q){
      sum+=Number(q.value||0)*Number(q.dataset.price||0);
    });
    if(totalEl)totalEl.textContent=money(sum,activeData&&activeData.currency_symbol);
  }
  function syncProduct(id){
    var resolved=resolveDataId(id),data=parseData(resolved);
    if(!data)return false;
    activeData=data;
    if(tourSelect.value!==resolved&&Array.prototype.some.call(tourSelect.options,function(o){return o.value===resolved}))tourSelect.value=resolved;
    titleEl.textContent=txt(data.title);
    imageEl.src=txt(data.image);
    imageEl.alt=txt(data.title);
    populateLanguages(data);
    buildTravelers(data);
    dateEl.value='';
    status('');
    scheduleDateRules();
    try{document.dispatchEvent(new CustomEvent('pmy:checkout-product-change',{detail:{data:data,id:resolved}}))}catch(e){}
    return true;
  }
  function selectedItems(){
    var out=[];
    document.querySelectorAll('#dynamic-travelers-container .traveler-qty').forEach(function(q){
      var n=Number(q.value||0);
      if(n>0)out.push({
        id:Number(q.dataset.variantId),
        quantity:n,
        label:q.dataset.label||'',
        choice:q.dataset.choice||''
      });
    });
    return out;
  }
  function fullPhone(){
    phoneEl&&phoneEl.dispatchEvent(new Event('input',{bubbles:true}));
    var full=txt(phoneFull&&phoneFull.value);
    if(full)return full;
    return txt($('prefix-code')&&$('prefix-code').textContent)+txt(phoneEl&&phoneEl.value).replace(/\D/g,'');
  }

  async function submit(){
    if(!activeData)return;
    status('');
    var name=txt(nameEl.value),email=txt(emailEl.value),phone=fullPhone(),date=txt(dateEl.value),language=txt(langSelect.value),preferred=txt(timeSelect.value);
    if(!name||!email||!phone||!date){status(cp('errorRequired','Please complete the required fields.'));return}
    if(blocked(date)){status(cp('errorDate','This date is not available.'));return}
    var requiresLanguage=!activeData.is_massage&&list(activeData.languages).length>0;
    if(requiresLanguage&&!language){status(cp('errorLanguage','Please select a language.'));return}

    var rows=selectedItems();
    if(!rows.length){status(cp('errorTravelers','Select at least one ticket.'));return}

    var items=rows.map(function(r){
      var props={'Data do Passeio':date,'Tipo de ingresso':r.label};
      props['_PMY Date']=date;
      props['_PMY Time']=r.choice||preferred||'';
      props['_PMY Language']=language||'';
      props['_PMY Product ID']=String(activeData.product_id||'');
      props['_PMY Product Handle']=txt(activeData.handle);
      props['_PMY Product Title']=txt(activeData.title);
      props['_PMY Variant ID']=String(r.id);
      props['_PMY Ticket Type']=r.label;
      if(r.choice)props['Opção selecionada']=r.choice;
      if(language)props['Idioma Escolhido']=language;
      if(preferred)props['Horário preferencial']=preferred;
      return{id:r.id,quantity:r.quantity,properties:props};
    });

    var original=bookBtn.textContent;
    bookBtn.disabled=true;
    bookBtn.textContent=cp('labelProcessing','Processing...');

    var note='PMY website checkout | '+txt(activeData.title)+' | '+date+(language?' | '+language:'')+(preferred?' | '+preferred:'');
    var checkoutAttributes={
      'PMY Customer Name':name,
      'PMY Customer Email':email,
      'PMY Customer WhatsApp':phone
    };
    var searchContext=window.PMYCheckoutContext||{};
    if(searchContext.people)checkoutAttributes['PMY Search Guests']=String(searchContext.people);
    if(window.PMYTracking&&typeof window.PMYTracking.getOrderAttributes==='function'){
      try{
        window.PMYTracking.getOrderAttributes().forEach(function(row){
          if(row&&row.name&&!Object.prototype.hasOwnProperty.call(checkoutAttributes,row.name)){
            checkoutAttributes[row.name]=String(row.value==null?'':row.value);
          }
        });
      }catch(e){}
    }
    if(window.PMYPostPurchaseAttribution&&typeof window.PMYPostPurchaseAttribution.getOrderAttributes==='function'){
      try{
        window.PMYPostPurchaseAttribution.getOrderAttributes().forEach(function(row){
          if(row&&row.name&&!Object.prototype.hasOwnProperty.call(checkoutAttributes,row.name)){
            checkoutAttributes[row.name]=String(row.value==null?'':row.value);
          }
        });
      }catch(e){}
    }

    try{
      if(!window.PMYNativeCheckout||typeof window.PMYNativeCheckout.start!=='function'){
        throw new Error('Secure PMY checkout is unavailable. Please try again.');
      }
      await window.PMYNativeCheckout.start({
        items:items,
        note:note,
        attributes:checkoutAttributes,
        customer:{first_name:name,email:email,phone:phone}
      });
    }catch(e){
      status(e&&e.message?e.message:cp('errorGeneric','We could not start checkout. Please try again.'));
      bookBtn.disabled=false;
      bookBtn.textContent=original;
    }
  }

  function trap(e){
    if(e.key!=='Tab'||!drawer.classList.contains('is-open'))return;
    var f=drawer.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])');
    if(!f.length)return;
    var first=f[0],last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
  }

  function init(){
    drawer=$('pmy-checkout-drawer');
    trigger=document.querySelector('[data-pmy-checkout-trigger]');
    backdrop=document.querySelector('[data-pmy-checkout-backdrop]');
    if(!drawer||!trigger||!backdrop)return;

    closeBtn=drawer.querySelector('[data-pmy-checkout-close]');
    tourSelect=$('tour-dropdown');
    titleEl=$('checkout-product-title');
    imageEl=$('checkout-product-image');
    nameEl=$('chk-name');
    emailEl=$('chk-email');
    phoneEl=$('chk-phone-number');
    phoneFull=$('chk-phone-full');
    dateEl=$('chk-date');
    langRow=$('checkout-lang-row');
    langSelect=$('checkout-lang-select');
    timeRow=$('checkout-time-row');
    timeSelect=$('checkout-time-select');
    travelers=$('dynamic-travelers-container');
    totalEl=$('checkout-total-display');
    statusEl=$('pmy-checkout-status');
    bookBtn=$('chk-book-btn');

    trigger.onclick=toggleDrawer;
    backdrop.onclick=closeDrawer;
    closeBtn.onclick=closeDrawer;
    function checkoutCountry(){
      var home=document.querySelector('[data-pmy-home-2026]');
      var value=home&&home.getAttribute('data-pmy-country');
      if(value!=='italy'&&value!=='portugal')value=document.documentElement.getAttribute('data-pmy-destination');
      return value==='italy'?'italy':'portugal';
    }
    var checkoutGroups=Array.prototype.slice.call(tourSelect.querySelectorAll('optgroup[data-pmy-checkout-country]'));
    var renderedCheckoutCountry=null;
    function filterCheckoutCountry(country){
      if(!checkoutGroups.length||document.body.classList.contains('template-product'))return;
      country=country==='italy'?'italy':'portugal';
      if(renderedCheckoutCountry===country)return;
      var current=tourSelect.value;
      checkoutGroups.forEach(function(group){if(group.parentNode===tourSelect)tourSelect.removeChild(group);});
      checkoutGroups.forEach(function(group){
        if(group.getAttribute('data-pmy-checkout-country')===country)tourSelect.appendChild(group);
      });
      renderedCheckoutCountry=country;
      var available=Array.prototype.slice.call(tourSelect.options);
      if(!available.length){
        tourSelect.selectedIndex=-1;activeData=null;titleEl.textContent='';
        imageEl.removeAttribute('src');
        return;
      }
      var selected=available.some(function(option){return option.value===current})?current:available[0].value;
      tourSelect.value=selected;
      /* Defer costly product/date/variant rebuilding until the drawer opens. */
      if(drawer.classList.contains('is-open')&&(!activeData||resolveDataId(selected)!==resolveDataId('pmy-checkout-data-'+activeData.product_id)))syncProduct(selected);
    }
    function onCountryChanged(country){
      country=country==='italy'?'italy':'portugal';
      if(renderedCheckoutCountry===country)return;
      if(drawer.classList.contains('is-open'))closeDrawer();
      filterCheckoutCountry(country);
    }
    window.addEventListener('pmy:destination-change',function(e){onCountryChanged(e.detail&&(e.detail.country||e.detail.destination))});
    document.addEventListener('pmy:country-change',function(e){onCountryChanged(e.detail&&e.detail.country)});
    tourSelect.onchange=function(){syncProduct(tourSelect.value)};
    dateEl.onchange=function(){
      if(blocked(dateEl.value)){
        dateEl.value='';
        status(cp('errorDate','This date is not available.'));
      }else status('');
    };
    bookBtn.onclick=submit;
    drawer.addEventListener('keydown',trap);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('is-open'))closeDrawer()});

    if(tourSelect.options.length)syncProduct(tourSelect.value||tourSelect.options[0].value);
    filterCheckoutCountry(checkoutCountry());

    window.PMYCheckoutDrawer={
      open:openDrawer,
      close:closeDrawer,
      toggle:toggleDrawer,
      select:function(id){if(syncProduct(id))openDrawer()},
      getActiveData:function(){return activeData},
      isDateBlocked:blocked,
      refreshDateRules:applyDateRules
    };
    window.toggleMobileCheckout=toggleDrawer;
    window.triggerCheckout=function(id,isUserClick){
      var ok=syncProduct(id);
      if(ok&&isUserClick!==false)openDrawer();
      return ok;
    };
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();